//function internalOpenVehiclePicker(make, model, year, trim, engine, redirect_url)
const get = require('lodash/get');
const isEmpty = require('lodash/isEmpty');
const { handleGarageData } = require('public/js/components/garage-store.js');
const { buildActiveYearOptions } = require('public/js/components/vehicle-picker-years.js');

require('public/css/components/vehicle-picker.scss');

const clearGarageCache = () => { handleGarageData.clearGarageCache(); };

/**
 * Vehicle Picker
 * @author aspencer
 * @dependencies: jquery
 */
'use strict';

// var window.rp_app.activeMakes = [{"ui":"Acura","url":"acura","start_year":"1986","end_year":"2016"}];
// var window.rp_app.activeMakes = [{"ui":"Scion","url":"scion","start_year":"2004","end_year":"2015"},{"ui":"Toyota","url":"toyota","start_year":1985,"end_year":"2015"}];
window.rp_app = window.rp_app || {};
// Allow for plugin to override the window object
rp_app.location = window.$location || require('public/js/lib/location')(window);
window.rp_app.vp_autoload_store = {};
window.rp_app.iframe = {};

/* Running index of the different pickers
.*-----------------------------------------*/
var _vp_index = 0;
var _vp_global_picker;
var redirect_helper = null;

const getDataAndOpenVehiclePicker = function (props = {}) {
	const isIframedPage = get(window.rp_app, 'data.plugin_iframe_page') || false;
	const hasMakesData = get(window.rp_app, 'activeMakes.length') || false;

	if (!hasMakesData && !isIframedPage) {
		$ajax({
			dataType: 'json',
			url: '/ajax/vehicle-picker/makes/all',
			success: function (response/*, type, xhr*/) {
				window.rp_app.activeMakes = response;
				//This call is added by the getVehiclePicker Method
				window.openVehiclePicker(props);
			},
		});
	} else {
		//open modal after script load
		//if loaded previously then just open the picker
		window.openVehiclePicker(props);
	}
};

/**
 * trapFocus method
 * NOTE: this method traps focus of the element witin the modal
 *
 * @param Object	modal element
 * @return null
 */
const trapFocus = function ($modal) {
	var focusableElements = $modal.find('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
	var firstFocusable = focusableElements.first();
	var lastFocusable = focusableElements.last();

	// Focus the first element when the modal is shown
	firstFocusable.focus();

	// Add keydown event to trap focus
	$modal.on('keydown', function(e) {
		var isTabPressed = (e.key === 'Tab' || e.keyCode === 9);

		if (!isTabPressed) {
			return;
		}

		if (e.shiftKey) { // Shift + Tab
			if (rp$(document.activeElement).is(firstFocusable)) {
				lastFocusable.focus();
				e.preventDefault();
			}
		} else { // Tab
			if (rp$(document.activeElement).is(lastFocusable)) {
				firstFocusable.focus();
				e.preventDefault();
			}
		}
	});
};

/**
 * openVehiclePicker method
 * NOTE: this function OVERRIDES a method already in the global space
 *
 * @author aspencer
 * @param
 * @return null
 */
window.openVehiclePicker = window.handleOpenVehiclePicker = function (args = {}) {
	const { make, model, year, trim, engine, redirect } = args;

	if (window.rp_app?.split?.track) {
		window.rp_app.split.track(window.rp_app.split.consts.VP_CLICK);
		if (document.getElementById('page-product')) {
			window.rp_app.split.track(window.rp_app.split.consts.PRODUCT_VP_CLICK);
		}
	}

	var $picker_wrapper = rp$('#vp_global_vpicker');
	if ($picker_wrapper.length === 0) {
		rp$('#rp_webstore').append('<div id="vp_global_vpicker"></div>');
		$picker_wrapper = rp$('#vp_global_vpicker');
	}

	redirect_helper = redirect;
	/* If Picker doesn't exist, create an element for it
	.*-----------------------------------------*/
	if (!_vp_global_picker) {
		//var picker_ele = rp$('<div id="vp_global_vpicker" style="display:none"></div>"');
		var picker_ele = rp$('<div id="vp_main_vpicker"></div>"');
		$picker_wrapper.append(picker_ele);
		_vp_global_picker = rp$('#vp_main_vpicker').vehiclepicker({
			display: 'none'
		});
	}

	/* Get the picker
	.*-----------------------------------------*/
	var global_vpicker = _vp_global_picker.vpicker();
	var target_step = 'make';


	/* Set the defaults from the function
	.*-----------------------------------------*/
	global_vpicker.clear_steps();
	global_vpicker.set_default_make(null);
	if (year) {
		global_vpicker.set_default_step('year', year);
		target_step = 'make';
	}
	if (make) {
		global_vpicker.set_default_make(make);
		global_vpicker.set_default_step('make', make);
		target_step = 'model';
	}
	if (model) {
		global_vpicker.set_default_step('model', model);
		target_step = 'trim';
	}
	if (trim) {
		global_vpicker.set_default_step('trim', trim);
		target_step = 'engine';
	}
	if (engine) {
		global_vpicker.set_default_step('engine', engine);
		target_step = 'final';
	}

	/* Set the redirect url
	.*-----------------------------------------*/
	global_vpicker.redirect_uri = null;
	if (redirect) {
		global_vpicker.redirect_uri = redirect;
	}

	/* Set the type (currently based off of redirect url)
	.*-----------------------------------------*/
	global_vpicker.set_picker_type('normal');
	if (redirect && redirect === 'accessories') {
		global_vpicker.set_picker_type('accessories');
	}

	/* Final Steps. Update the default selection & start the chooser
	.*-----------------------------------------*/
	global_vpicker.update_default_selected();
	if (target_step !== 'final') {
		global_vpicker.reset_to_step(target_step);
	}
	global_vpicker.start_chooser();
	global_vpicker.select_next_tab();
};

/**
 * VehiclePicker constructor class
 *
 * @author aspencer
 * @param  Object 		init_options	user-provided options
 * @param  DomElement 	ele 			DOM Element of main object
 */
var RP_VehiclePicker = function (init_options, ele) {

	/* Setup
	.*-----------------------------------------*/
	this.step_info = {
		year: {
			title: window.javascriptContent.year,
			descr: '',
			level: 'main'
		},
		make: {
			title: window.javascriptContent.make,
			descr: '',
			level: 'main'
		},
		model: {
			title: window.javascriptContent.model,
			descr: '',
			level: 'main'
		},
		trim: {
			title: window.javascriptContent.trim,
			descr: '',
			level: 'sub'
		},
		engine: {
			title: window.javascriptContent.engine_transmission,
			descr: '',
			level: 'sub'
		}
	};

	this.flyoutTimer = null;

	this.optionsHeaderText = window.javascriptContent.choose_vehicle_text;

	/* Define DOM Elements
	.*-----------------------------------------*/
	this.$ele = rp$(ele); // wrapper element
	this.$chooser = null; // chooser element

	/* Define this chooser's index and IDs
	.*-----------------------------------------*/
	this.vp_idx = _vp_index++;
	this.ele_id = this.vp_idx;
	this.chooser_id = 'rp_vehiclepicker_chooser_' + this.vp_idx;
	this.display_id = 'rp_vehiclepicker_display_' + this.vp_idx;
	if (this.$ele.attr('id')) {
		this.ele_id = this.$ele.attr('id').replace('rp_vp_', '');
	}

	/* Redirection URL
	.*-----------------------------------------*/
	this.redirect_uri = null;

	/* Set the type of vehicle picker
	.*-----------------------------------------*/
	this.picker_type = 'normal';

	/* Handle Options
	.*-----------------------------------------*/
	var default_options = {
		header: this.optionsHeaderText,
		display: 'classic',
		steps: ['year', 'make', 'model', 'trim', 'engine'],
		display_steps: ['year', 'make', 'model', 'trim', 'engine']
	};
	this.options = rp$.extend(default_options, init_options);

	/* AJAX retries
	.*-----------------------------------------*/
	this.ajax_max_retries = 5;
	this.ajax_error_log = [];

	/* Set up variable for selected values
	.*-----------------------------------------*/
	this.selected = {};
	this.default_make = null;
	this.default_make_used = false;

	/* Run the initialization function
	.*-----------------------------------------*/
	this.init();
};

/**
 * Initialize the element based on parameters
 *
 * @author aspencer
 * @return null
 */
RP_VehiclePicker.prototype.init = function () {
	// Clear out the 'loader' class
	var $loader = this.$ele.find('.vehiclepicker_display_loading').first();
	$loader.remove();

	// Now fill in the base templates
	var $picker_wrapper = rp$('#vp_global_vpicker');
	if ($picker_wrapper.length === 0) {
		rp$('#rp_webstore').append('<div id="vp_global_vpicker"></div>');
		$picker_wrapper = rp$('#vp_global_vpicker');
	}

	$picker_wrapper.append(this.html_base());

	// Collect the new main elements
	this.$chooser = rp$('#' + this.chooser_id);
	this.$display = this.$ele.find('.rp_vehiclepicker_display').first();

	/* Get any step defaults from the element
	.*-----------------------------------------*/
	var update_defaults = false;
	for (var i = 0, j = this.options.steps.length; i < j; i++) {
		var step = this.options.steps[i];
		var default_value = this.$ele.attr('data-' + step);
		if (default_value && step === 'make') {
			this.set_default_make(default_value);
		}
		if (default_value) {
			this.set_default_step(step, default_value);
			update_defaults = true;
		}
	}

	if (update_defaults) {
		this.update_default_selected();
	}

	/* Get Default redirect uri
	.*-----------------------------------------*/
	if (this.$ele.attr('data-redirect-uri')) {
		this.redirect_uri = this.$ele.attr('data-redirect-uri');
	}

	/* Attach events to the widget
	.*-----------------------------------------*/
	var self = this;
	this.$ele.on('mousedown', '.rp_start_chooser, .vehiclepicker_display_overlay, .vpicker_button, select, input', function VP_MouseDown(event) {
		event.preventDefault();
		self.start_chooser();
	});
	this.$chooser.on('click', '.vp_cancel_button, .vp_closer a', function VP_CancelButton_Click() {
		self.stop_chooser();
	});
	this.$chooser.on('click', '.vp_reset_button', function VP_ResetButton_Click(e) {
		if (e.stopPropagation) {
			e.stopPropagation();
		} else {
			e.cancelBubble = true;
		}
		self.reset_chooser();
	});
	this.$chooser.on('click', '.vp_chooser_bc', function VP_Breadcrumb_Click(e) {
		if (e.stopPropagation) {
			e.stopPropagation();
		} else {
			e.cancelBubble = true;
		}
		var step = rp$(this).attr('data-step');
		var step_active = rp$(this).hasClass('selected');
		if (step_active) {
			self.reset_to_step(step);
		}
	});
	this.$chooser.on('click', '.vp_option', function VP_Option_Click(e) {
		if (e.stopPropagation) {
			e.stopPropagation();
		} else {
			e.cancelBubble = true;
		}

		var opt_value = rp$(this).attr('data-value');
		var opt_type = rp$(this).attr('data-type');
		var opt_display = rp$(this).attr('data-display');
		self.selected[opt_type] = { display: opt_display, value: opt_value };
		if(opt_type === 'make')
		{
			var opt_primary_make = rp$(this).attr('data-primary-make');
			self.selected[opt_type].primary_make = opt_primary_make;
		}
		self.select_next_tab();
	});
	this.$chooser.on('click', '.vp_select_vehicle', function VP_SelectVehicle_Click() {
		self.select_vehicle();
	});

	this.$chooser.on('click', '.vehicle-count', function VP_VehicleCount_Click(e) {
		e.preventDefault();
		rp$('.vehicle-list').fadeIn('fast');
		self.flyoutTimer = window.setTimeout(function () {
			rp$('.vehicle-list').fadeOut('fast');
		}, 2000);
	});
	this.$chooser.on('mouseenter', '.vehicle-list', function VP_VehicleList_MouseEnter() {
		clearTimeout(self.flyoutTimer);
	});

	this.$chooser.on('mouseleave', '.vehicle-list', function VP_VehicleList_MouseLeave() {
		self.flyoutTimer = window.setTimeout(function () {
			rp$('.vehicle-list').fadeOut('fast');
		}, 800);
	});

	// When a recent vehicle link is clicked
	this.$chooser.on('click', '.vp-recent-vehicles .recent-vehicle', function VP_RecentVehicle_Click(e) {
		e.preventDefault();
		self.recentVehicleHandler(e, rp$(this));
	});

	/* Select the first unfilled tab
	.*-----------------------------------------*/
	//this.select_next_tab();

	/* Finally, if the user has clicked on the "loading" screen, start the process
	.*-----------------------------------------*/
	var target_ele_id = 'rp_vp_' + this.ele_id;
	if (typeof rp_app.vp_autoload_store[target_ele_id] !== 'undefined') {
		this.start_chooser();
	}

};

RP_VehiclePicker.prototype.set_default_step = function (step, value) {
	var display_value = (step === 'year') ? value : '';
	var def_opt_obj = { display: display_value, value: value };
	this.selected[step] = def_opt_obj;
};

RP_VehiclePicker.prototype.clear_steps = function () {
	this.selected = {};
};

/********************************************
 * Action Methods
 * Contains most of the business logic of the picker
 * -----------------------------------------
 * @section actions
 ********************************************/

/**
 * Loop through the steps, determine what has been filled out, and
 * go to the next step
 *
 * @author aspencer
 * @return null
 */
RP_VehiclePicker.prototype.select_next_tab = function () {
	var i, j, step, next_step = false;
	var self = this;

	for (i = 0, j = this.options.steps.length; i < j; i++) {
		step = this.options.steps[i];

		/* If step is the first non-filled out
		.*-----------------------------------------*/
		if (!next_step && typeof this.selected[step] === 'undefined') {
			next_step = step;
		}

		/* If the step is filled out, update the display
		.*-----------------------------------------*/
		if (typeof this.selected[step] !== 'undefined') {
			this.select_step(step, this.selected[step]);
		} else {
			this.deselect_step(step);
		}
	}

	this.build_chooser_display();

	/* If there are no unfilled steps, get the final url
	.*-----------------------------------------*/
	if (next_step === false) {
		this.select_tab('final');
		this.select_vehicle();
	} else if (next_step === 'trim') {
		const trimsAjaxHandler = (data/*, textStatus, xhr*/) => {
			if (!data || !data.length) {
				self.select_tab('final');
				self.select_vehicle();
			} else {
				self.select_tab(next_step, data);
			}
		};

		// Preload the trims to see if we may already have a full vehicle (ex: motorcycle)
		const request_body = this.get_request_body_for_step_options(next_step);
		$ajax({
			dataType: 'json',
			data: request_body,
			url: '/ajax/vehicle-picker/next',
			success: trimsAjaxHandler,
		});
	} else {
		this.select_tab(next_step);
	}
};


/**
 * Get the options for a specific step from the server
 *
 * @author aspencer
 * @param  string 		step 		Step to get options for
 * @return null
 */
RP_VehiclePicker.prototype.get_step_options = function (step, preloaded_data = null) {
	/* Build Parameters for selection
	.*-----------------------------------------*/
	var $options_wrapper, loader_timeout, selected_year;
	var self = this;
	var array_options = [];
	var primary_make_options = [];
	var secondary_make_options = [];
	/* Get DOM Elements & clear it
	.*-----------------------------------------*/
	({ $options_wrapper } = this.get_tab_options(step));
	$options_wrapper.empty();

	/* Fade In a loader
	.*-----------------------------------------*/
	$options_wrapper.append('<div class="vp_chooser_loading"><span class="fa fa-spinner fa-spin"></span> ' + window.javascriptContent.loading + '</div>');
	loader_timeout = window.setTimeout(function () {
		$options_wrapper.find('.vp_chooser_loading').fadeIn(500);
	}, 300);

	/* Load the data
	.*-----------------------------------------*/
	if (step === 'make' && this.picker_type !== 'accessories') {

		if (!this.default_make_used && this.default_make) {
			/* Only use filtered makes if we haven't done so already
			.*-----------------------------------------*/
			array_options = this.get_filtered_makes();
		} else {
			/* Otherwise, get the active makes
			.*-----------------------------------------*/
			if (this.options.steps[0] === 'year' && this.selected.year) {
				// filtered by year if year is the first step
				selected_year = this.selected.year.value;
				array_options = this.makes_for_year(selected_year);
			} else {
				// All makes if not
				array_options = window.rp_app.activeMakes;
			}
		}
		primary_make_options = array_options.filter( item => parseInt(item.primary_make) );
		secondary_make_options = array_options.filter( item => !parseInt(item.primary_make) );
		this.build_step_options(step, primary_make_options);
		if(primary_make_options.length > 0 && secondary_make_options.length > 0 ){
			({ $options_wrapper } = this.get_tab_options(step));

			this.$chooser.find('.vp_main').scrollTop(0);

			let content = $options_wrapper.html();
			content += '<hr class="rounded">';
			$options_wrapper.html(content);
		}
		this.build_step_options(step, secondary_make_options, true);
		({ $options_wrapper } = this.get_tab_options(step));
		if ($options_wrapper.find('.vp_option').length === 0) {
			this.display_empty_options(step);
		}
		if (!this.default_make_used && this.default_make) {
			/* Only use filtered makes if we haven't done so already
			.*-----------------------------------------*/
			this.default_make_used = true;
		}
	} else if (step === 'year' && this.picker_type !== 'accessories' && !this.selected.model) {
		this.build_step_options(step, this.get_active_years());
		// Set focus to close button so that next tab navigates to first year
		window.setTimeout(() => {
			rp$('#close_vehicle_picker_' + this.chooser_id + '').focus();
		}, 500);
	} else {
		if (preloaded_data) {
			window.clearTimeout(loader_timeout);
			return self.build_step_options(step, preloaded_data);
		}

		/* Request the options from the server
		.*-----------------------------------------*/
		const variables = this.get_request_body_for_step_options(step);

		$ajax({
			dataType: 'json',
			data: variables,
			url: '/ajax/vehicle-picker/next',
			success: function (response/*, type, xhr*/) {
				window.clearTimeout(loader_timeout);
				self.build_step_options(step, response);
			},
			error: function () {
				window.clearTimeout(loader_timeout);
				self.display_fatal_error();
			},
		});
	}
};

/**
 * Build the HTML for the current options
 *
 * @author aspencer
 * @param  string  		step 		Current step to display
 * @param  array   		data 		Return data of type [{ui: '',url:''}...]
 * @return null
 */
RP_VehiclePicker.prototype.build_step_options = function (step, data, allowStack=null) {

	/* Get DOM Elements
	.*-----------------------------------------*/
	const { $options_wrapper } = this.get_tab_options(step);

	this.$chooser.find('.vp_main').scrollTop(0);

	var full_option_html = '';
	var previous_html = '';
	const hasOptions = Array.isArray(data) && data.length > 0;

	// Empty non-stack responses must clear the loader; otherwise vp_chooser_loading stays forever.
	if (!allowStack && !hasOptions) {
		if (step === 'make') {
			$options_wrapper.find('.vp_chooser_loading').remove();
			if (this.picker_type === 'accessories') {
				this.display_empty_options(step);
			}
			return;
		}
		this.display_empty_options(step);
		return;
	}

	if(allowStack){
		// Remove the loader class div from the $options_wrapper since this isn't something we
		// want to stack above actual vehicle picker options
		$options_wrapper.find('.vp_chooser_loading').remove();
		previous_html = $options_wrapper.html();
		if (!hasOptions) {
			return;
		}
	}

	let mobileExperienceBreakpoint = 680;
	let currentViewportWidth = rp$(window).outerWidth();
	let isMobile = currentViewportWidth <= mobileExperienceBreakpoint;
	let totalColumns = step === 'trim' ? 2 : 4;	// Trims is 2 columns due to length of trim names

	// Let's figure out how many rows we'll need for the data; on mobile, every option is its own row
	var total_rows = isMobile ? data.length : Math.ceil(data.length / totalColumns);
	let optionRows = [];

	for (let i = 0; i < total_rows; i++) {
		optionRows.push([]);
	}

	/* Split results into respective rows and columns (ordered going down column, then onto next row)
	.*-----------------------------------------*/
	let current_row_num = 0;

	for (let i = 0, j = data.length; i < j; i++) {

		let optionInfo = data[i];
		optionRows[current_row_num].push(optionInfo);

		// Add option to next row down, until we can loop back around to first row again
		current_row_num++;
		if (current_row_num === total_rows) {
			current_row_num = 0;
		}
	}

	for (let i = 0, j = optionRows.length; i < j; i++) {
		var optionRow = optionRows[i];

		full_option_html += '<div class="vp_option_row">';

		/* Loop through each option row and render each individual option
		.*-----------------------------------------*/
		for (let ii = 0, jj = optionRow.length; ii < jj; ii++) {
			const option = optionRow[ii];
			const primary_make = option.primary_make !== 'undefined' ? '" data-primary-make="'+ option.primary_make :'';
			const displayText = option.ui || option.url || '';

			var option_html = '<a href="javascript:;" data-value="' + option.url + '" data-type="' + step +
				'" data-display="' + displayText + '" title="' + displayText + primary_make + '" class="vp_option">' + displayText + '</a>';
			full_option_html += option_html;
		}

		if (isMobile) {	// we don't need any placeholder elements on mobile since everything is on its own row
			full_option_html += '</div>';
			continue;
		}
		// Insert some filler elements to make sure all the picker options are aligned perfectly with 4 options per row
		for (let i = optionRow.length; i < totalColumns; i++) {
			var empty_option_html = '<span class="vp_option_placeholder"></span>';
			full_option_html += empty_option_html;
		}

		full_option_html += '</div>';
	}

	if (! isEmpty(full_option_html)) {
		if (! isEmpty(previous_html)) { // If we're stacking options, prepend the old HTML
			full_option_html = previous_html + full_option_html;
		}

		$options_wrapper.html(full_option_html);
	}

	/* If there is only one option left, select it
	.*-----------------------------------------*/
	let $children = $options_wrapper.find('.vp_option');
	if (data.length === 1) {
		if(step !== 'make' || (allowStack && $children.length === 1)){
			$children.first().click();
		}
	}
};


/**
 * Reset the chooser window and start over at the beginning
 *
 * @author aspencer
 * @return null
 */
RP_VehiclePicker.prototype.reset_chooser = function () {
	this.selected = {};
	this.select_next_tab();
	this.$chooser.find('.vp_chooser_error').remove();
};

/**
 * Resets the chooser to a specific step
 *
 * @author aspencer
 * @param  string 		step 		Target Step
 * @return null
 */
RP_VehiclePicker.prototype.reset_to_step = function (step) {
	/* Loop through selected steps and delete selections
	.*-----------------------------------------*/
	for (var i = this.options.steps.length - 1; i >= 0; i--) {
		var set_step = this.options.steps[i];
		delete this.selected[set_step];
		// If the current step is the reset step, break out of the loop
		if (set_step === step) {
			break;
		}
	}
	/* Select the next tab
	.*-----------------------------------------*/
	this.select_next_tab();
};

/**
 * Update the widget to reflect a selected step
 *
 * @author aspencer
 * @param  string		step 		ID for the step we're selecting
 * @param  object		option_obj 	Option object
 * @return null
 */
RP_VehiclePicker.prototype.select_step = function (step, option_obj) {
	let dispHtml = null;
	let displayValue = null;
	this.selected[step] = option_obj;

	if (step === 'year') {
		this.$chooser.find('.vp_chooser_disp').empty();
	}

	/* Update Display
	.*-----------------------------------------*/
	if (this.options.display === 'classic') {
		// Classic - add option and select it
		var option = '<option value="' + option_obj.value + '">' + option_obj.display + '</option>';
		var $select_ele = rp$(this.$display.find('select[name=partpicker_select-a-vehicle-link' + step + ']'));
		var first = $select_ele.find('option:first');
		$select_ele.empty().append(first).append(option).val(option_obj.value);
	}

	displayValue = option_obj?.display;
	if (displayValue !== undefined && displayValue !== null && displayValue !== '') {
		dispHtml = (this.$chooser.find('.vp_chooser_disp').is(':empty')) ? displayValue : ' <i class="fa fa-angle-right"></i> ' + displayValue;
	}

	/* Update Chooser
	.*-----------------------------------------*/
	if (dispHtml !== null && dispHtml !== undefined) {
		this.$chooser.find('.vp_chooser_disp').append(dispHtml);
	}
	this.$chooser.find('.vp_chooser_bc_' + step).addClass('selected');
};

/**
 * Update the widget to reflect a deselected step
 *
 * @author aspencer
 * @param  string		step 		ID for the step we're selecting
 * @param  string		value 		Selected Value
 * @return null
 */
RP_VehiclePicker.prototype.deselect_step = function (step) {
	delete this.selected[step];

	if (step === 'year') {
		this.$chooser.find('.vp_chooser_disp').empty();
	}

	/* Update Display
	.*-----------------------------------------*/
	if (this.options.display === 'classic') {
		// Classic - Remove Option
		var $select_ele = rp$(this.$display.find('select[name=partpicker_select-a-vehicle-link' + step + ']'));
		var first = $select_ele.first().html();
		$select_ele.empty().append(first).val('');
	}

	/* Update Chooser
	.*-----------------------------------------*/
	this.$chooser.find('.vp_chooser_bc_' + step).removeClass('selected');
};


RP_VehiclePicker.prototype.build_chooser_display = function () {
	var $chooserDisp, optionHtml,
		isEmpty = true;

	$chooserDisp = this.$chooser.find('.vp_chooser_disp');
	$chooserDisp.empty();

	rp$.each(this.selected, function Selected_Iterator(step, step_obj) {
		let display = step_obj?.display;
		if (display !== undefined && display !== null && display !== '') {
			optionHtml = '<span class="step_display display_' + step + '">' + display + '</span>';
			$chooserDisp.append(optionHtml);
			isEmpty = false;
		}
	});

	if (isEmpty) {
		$chooserDisp.hide();
	} else {
		$chooserDisp.show();
	}
};


/**
 * Update the widget to reflect a selected step
 *
 * @author aspencer
 * @param  string		step 		ID for the step we're selecting
 * @param  string		value 		Selected Value
 * @return null
 */
RP_VehiclePicker.prototype.select_tab = function (step, preloaded_data = null) {

	/* First, Update the UI
	.*-----------------------------------------*/
	this.$chooser.find('.vp_chooser_bc').removeClass('active');
	this.$chooser.find('.vp_chooser_bc_' + step).addClass('active');
	this.$chooser.find('.vp_chooser_tab').removeClass('active');
	this.$chooser.find('.vp_chooser_tab_' + step).addClass('active');

	/* Now, get the selection options
	.*-----------------------------------------*/
	if (step !== 'final') {
		this.get_step_options(step, preloaded_data);
	} else {
		this.display_final_step();
	}
};

/**
 * Move the Tab to the final step of the process, which displays vehicle and CTA
 *
 * @author aspencer
 * @return null
 */
RP_VehiclePicker.prototype.display_final_step = function () {

	var $tab = this.$chooser.find('.vp_chooser_tab_final').first();
	var $options_wrapper = $tab.find('.vp_final_display').first();
	$options_wrapper.empty();

	var final_html = '<div class="vp_final_disp_main">';
	final_html += this.html_vehicle_display();
	final_html += '</div>'; // .vp_final_disp_main
	$options_wrapper.html(final_html);
};

/**
 * Select the vehicle: register the vehicle with the system and redirect
 *
 * @author aspencer
 * @return null
 */
RP_VehiclePicker.prototype.select_vehicle = function () {
	const variables = {};
	const redirectUri = this.redirect_uri || '';
	const steps = this.options.steps;

	for (const step of steps) {
		const selected = this.selected[step];
		if (selected !== undefined) {
			variables[step] = selected.value;
		}
	}

	if (variables.trim === undefined) {
		variables.trim = '';
	}
	if (variables.engine === undefined) {
		variables.engine = '';
	}
	variables.page = rp_app?.env?.page ?? '';
	variables.path = rp_app?.location?.pathname ?? '';

	if (redirectUri) {
		variables.redirect_url = redirectUri;
	}

	this.ajax_request('/ajax/vehicle-picker/select', variables, function (data) {
		clearGarageCache();
		const redirectUrl = data?.redirect_url;
		if (redirectUrl) {
			rp_app.location.redirect(redirectUrl);
		} else {
			rp_app.location.reload();
		}
	});
};

RP_VehiclePicker.prototype.update_default_selected = function () {

	/* Build Parameters for selection
	.*-----------------------------------------*/
	var variables = {};
	variables.type = 'update_defaults_json';
	variables.selected = {};
	for (var opt_step in this.selected) {
		var option_obj = this.selected[opt_step];
		variables[opt_step] = option_obj.value;
	}

	variables['redirect'] = redirect_helper;

	/* Send Data and parse the results
	.*-----------------------------------------*/
	var self = this;

	$ajax({
		url: '/ajax/vehicle-picker/defaults',
		data: variables,
		dataType: 'json',
		success: function (data/*, textStatus, xhr*/) {
			if (data.redirectUri && self.redirect_uri !== 'accessories') {
				self.redirect_uri = data.redirectUri;
				delete data.redirectUri;
			}
			for (var step in data) {
				var step_data = data[step];
				self.select_step(step, step_data);
			}
		}
	});
};

/********************************************
 * Fancybox methods
 * -----------------------------------------
 * @section fancybox
 ********************************************/

/**
 * Open up the Chooser Element
 *
 * @author aspencer
 * @return null
 */
RP_VehiclePicker.prototype.start_chooser = function () {
	var $dialogEle, frameScroll;
	var $modalEl = rp$('#rp_vp_wrap_' + this.chooser_id);
	var $mainContent = rp$('.main');
	$mainContent.attr('aria-hidden', 'true');

	if ($modalEl.length === 0) {
		this.init();
		$modalEl = rp$('#rp_vp_wrap_' + this.chooser_id);
	}

	$dialogEle = $modalEl.find('.modal-dialog');
	$dialogEle.removeAttr('style');

	/* Select the first unfilled tab
	.*-----------------------------------------*/
	this.select_next_tab();

	/* If Window is tall, determine where best to render the modal
	.*-----------------------------------------*/
	if (rp_app.iframe.height) {
		// Only set the margin if we have scrolled beyond the top of the frame
		if (rp_app.iframe.scroll && rp_app.iframe.scroll > rp_app.iframe.offset.top) {
			frameScroll = rp_app.iframe.scroll - rp_app.iframe.offset.top; // amount scrolled over frame
			$dialogEle.css('margin-top', frameScroll + 30);
		}
	}

	/* Open fancybox
	.*-----------------------------------------*/
	// Determine whether or not to use the modal backdrop
	// On Plugin stores, we can't count on backdrops working properly
	var displayBackdrop = true;
	if (window.__IS_WEBSTORE_PLUGIN === true) {
		var mobileExperienceBreakpoint = 680;
		var currentViewportWidth = rp$(window).outerWidth();
		displayBackdrop = (currentViewportWidth > mobileExperienceBreakpoint);
	}
	$modalEl.modal({
		backdrop: displayBackdrop,
	});


	$modalEl.off('hide.bs.modal');

	$modalEl.on('hide.bs.modal', function (/*e*/) {
		$mainContent.removeAttr('aria-hidden');
		$dialogEle.off('keydown');
	}.bind(this));

	trapFocus($dialogEle);
};

/**
 * Close the Chooser Element
 *
 * @author aspencer
 * @return null
 */
RP_VehiclePicker.prototype.stop_chooser = function () {
	rp$('#rp_vp_wrap_' + this.chooser_id).modal('hide');
};

/********************************************
 * HTML functionality
 * -----------------------------------------
 * @section html
 ********************************************/

/**
 * Builds the complete HTML
 *
 * @author aspencer
 * @return static for the display
 */
RP_VehiclePicker.prototype.html_base = function () {
	var html = '<div class="rp_vehiclepicker">';
	// if(this.options.display !== 'none') {
	// 	html += this.html_display();
	// }
	html += this.html_chooser();
	html += '</div>'; // .rp_vehiclepicker
	return html;
};

/**
 * Define the HTML for the display element
 * ---------
 * @TODO: add ability to define different displays
 *
 * @author aspencer
 * @return static for the display
 */
RP_VehiclePicker.prototype.html_display = function () {
	var html = '<div class="rp_vehiclepicker_display" id="' + this.display_id + '">';
	html += this.html_display_classic();
	html += '</div>'; // .rp_vehiclepicker_display
	return html;
};

/**
 * Define the HTML for the classic display element
 * ---------
 *
 * @author aspencer
 * @return static html for the classic display
 */
RP_VehiclePicker.prototype.html_display_classic = function () {
	var html = '<div class="rp_vehiclepicker_display_classic">';

	html += '<div class="container-vehicle-dd-' + this.ele_id + ' box-vehicle-picker">';
	for (var i = 0, j = this.options.steps.length; i < j; i++) {
		var step = this.options.steps[i];
		var step_info = this.step_info[step];
		html += '<span class="partpicker_' + this.ele_id + step + 'span">';
		html += '<select name="partpicker_select-a-vehicle-link' + step + '" class="search-boxes styled-select" readonly="true" id="partpicker_' + this.ele_id + step + '">';
		html += '<option value="">- Choose ' + step_info.title + ' -</option>';
		html += '</select>';
		html += '</span>';
	}
	html += '<input id="partpicker_' + this.ele_id + '-submit" type="button" value="Select" class="disp_input_submit btn" />';
	html += '</div>'; // .box-vehicle-picker

	html += '</div>'; // .rp_vehiclepicker_display_classic

	return html;
};

/**
 * Define the HTML for the chooser element
 * ---------
 * The chooser element is content that displays in an iframe, and is a
 * collection of tabs that we dynamically fill with options
 *
 * @author aspencer
 * @return static html for the chooser
 */
RP_VehiclePicker.prototype.html_chooser = function () {
	var step, step_info, i, j, html;

	html = '<div class="rp_vehiclepicker_wrapper modal fade" id="rp_vp_wrap_' + this.chooser_id + '">';
	html += '<div class="modal-dialog" role="dialog" aria-labelledby="rp_vehiclepicker_chooser" aria-modal="true" tabindex="-1">';
	html += '<div class="rp_vehiclepicker_chooser modal-content" id="' + this.chooser_id + '">';
	html += '<div class="vp_closer"><button id="close_vehicle_picker_' + this.chooser_id + '" type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">' + window.javascriptContent.close + '</span></button></div>';
	//<a href="javascript: void(0);">&times;</a></div>';
	html += '<div class="vp_head">';
	html += '<div id="rp_vehiclepicker_chooser" class="vp_chooser_h1">' + this.options.header + '</div>';
	html += '</div>'; // .vp_head
	html += '<div class="vp_chooser_disp">';
	//html += this.html_vehicle_display();
	html += '</div>'; // .vp_chooser_display

	html += '<ul class="vp_breadcrumbs">';
	for (i = 0, j = this.options.steps.length; i < j; i++) {
		step = this.options.steps[i];
		step_info = this.step_info[step];
		html += '<li class="vp_chooser_bc vp_chooser_bc_' + step + '" data-step="' + step + '">';
		html += step_info.title;
		html += '</li>';
	}
	html += '</ul>'; // .vp_breadcrumbs

	html += '<div class="vp_main">';

	for (i = 0, j = this.options.steps.length; i < j; i++) {
		step = this.options.steps[i];
		step_info = this.step_info[step];
		html += '<div class="vp_chooser_tab vp_chooser_tab_' + step + '">';
		//html += '<h2>'+ step_info.title +'</h2>';
		html += '<div class="vp_chooser_tab_options">';
		html += '</div>'; // .vp_chooser_tab_options
		html += '</div>'; // .vp_chooser_tab
	}

	html += '<div class="vp_chooser_tab vp_chooser_tab_final">';
	html += '<div class="vp_final_display">';
	html += '</div>'; // .vp_final_display

	html += '<div class="vp_final_control">';
	//html += '<a href="javascript:;" class="large wide green button vp_select_vehicle">Shop for <span class="vp_picker_type_shopfor">Parts</span></a>';
	html += '<i class="fa fa-spinner fa-spin fa-3x"></i>';
	html += '</div>'; // .vp_final_control
	html += '</div>'; // .vp_chooser_tab

	html += '</div>'; // .vp_main
	html += this.recentVehiclesHtml();
	html += '<div class="vp_control">';
	html += '<a href="javascript:;" class="button vp_reset_button">' + window.javascriptContent.start_over + '</a>';
	html += '<a href="javascript:;" class="button vp_cancel_button" data-dismiss="modal">' + window.javascriptContent.close + '</a>';
	html += '</div>'; // .vp_control

	html += '</div>'; // .rp_vehiclepicker_chooser
	html += '</div>'; // .modal-dialog
	html += '</div>'; // .rp_vehiclepicker_wrapper

	return html;
};

// Handles when a recent vehicle link is clicked
RP_VehiclePicker.prototype.recentVehicleHandler = function (e, $a) {
	var self = this;
	var timeoutCleared = false;
	var data = {
		type: 'set_parts_model',
		product: 'auto',
		redirect_url: self.redirect_uri,
		recent_vehicle: true,
	};

	function ajaxHandler(data, textStatus, xhr) {
		if (timeoutCleared === false) {
			setTimeout(function () { ajaxHandler(data, textStatus, xhr); }, 100);
		} else if (data) {
			clearGarageCache();
			rp_app.location.redirect(data);
		}
	}

	if (self.redirect_uri) {
		rp$.each($a.data(), function (i, v) {
			data[i] = v;
		});

		// Need to actually add a spinner... realized only the final tab has it
		setTimeout(function () {
			timeoutCleared = true;
		}, 1);

		if (rp_app.env.page) {
			data.page = rp_app.env.page;
		}

		self.ajax_request('/ajax/vehicle-picker/select', data, ajaxHandler);
	} else {
		clearGarageCache();
		rp_app.location.redirect($a.data('url'));
	}
};

// Builds the html for recent vehicles
RP_VehiclePicker.prototype.recentVehiclesHtml = function () {
	var cars = [], // RP_GLOBALS.savedCars,
		selectedCar = null,
		carsHtml = '',
		html = '';

	function buildAnchor(car) {
		var uiString = car.ui_year + ' ' + car.ui_make + ' ' + car.ui_model,
			attr = [];

		attr.push('class="recent-vehicle"');
		attr.push('href="javascript: void(0);"');
		if (car.year) {
			attr.push('data-year="' + car.year + '"');
		}
		if (car.make) {
			attr.push('data-make="' + car.make + '"');
		}
		if (car.model) {
			attr.push('data-model="' + car.model + '"');
		}
		if (car.trim) {
			attr.push('data-trim="' + car.trim + '"');
		}
		if (car.engine) {
			attr.push('data-engine="' + car.engine + '"');
		}
		if (car.url) {
			attr.push('data-url="' + car.url + '"');
		}

		return '<a ' + attr.join(' ') + '>' + uiString + '</a>';
	}

	if (cars.length > 0) {
		rp$.each(cars, function (i, v) {
			if (v.selected === true) {
				selectedCar = v;
			} else {
				carsHtml += '<li>' + buildAnchor(v) + '</li>';
			}
		});

		if (selectedCar === null) {
			selectedCar = cars[0];
		}

		html += '<div class="vp-recent-vehicles"><div class="recent-vehicles-content">';
		html += window.javascriptContent.recent_vehicles + ': <span class="selected-vehicle">' + buildAnchor(selectedCar) + '</span>';
		if (cars.length > 1) {
			html += '<a href="javascript: void(0);" class="vehicle-count">(+' + (cars.length - 1) + ' more) <i class="fa fa-chevron-up"></i></a>';
		}
		html += '</div><div class="vehicle-list flyout"><ul>';
		html += carsHtml;
		html += '</ul></div>';
		html += '</div>';

		return html;
	} else {
		return '';
	}
};

/**
 * Build Vehicle Display Markup - All steps split up by level
 *
 * @author aspencer
 * @return 	HTML for the Vehicle Display
 */
RP_VehiclePicker.prototype.html_vehicle_display = function () {
	var step, step_info, step_disp, level, disp_steps, disp_step, i, j;
	var disp_html = '';
	var disp = {
		main: [],
		sub: []
	};

	/* Loop through display steps and sort them into levels
	.*-----------------------------------------*/
	for (i = 0, j = this.options.display_steps.length; i < j; i++) {
		step = this.options.display_steps[i];
		step_info = this.step_info[step];
		step_disp = {
			step: step,
			display: ''
		};
		const display = this.selected?.[step]?.display;
		if (display !== undefined && display !== null && display !== '') {
			step_disp.display = display;
		}
		level = step_info.level;
		disp[level].push(step_disp);
	}

	/* Render HTML levels
	.*-----------------------------------------*/
	for (level in disp) {
		disp_steps = disp[level];
		disp_html += '<span class="vp_disp_lev_' + level + '">';
		for (i = 0, j = disp_steps.length; i < j; i++) {
			disp_step = disp_steps[i];
			disp_html += '<span class="vp_disp_' + disp_step.step + '">';
			disp_html += disp_step.display;
			disp_html += '</span> '; // .vp_disp_
		}
		disp_html += '</span>'; // .vp_disp_lev
	}

	return disp_html;
};

/********************************************
 * Utility Methods
 * -----------------------------------------
 * @section utils
 ********************************************/

/**
 * Get the Makes and filter them by our default_make if set
 *
 * @author aspencer
 * @return null
 */
RP_VehiclePicker.prototype.get_filtered_makes = function () {
	var year_makes = [];

	/* Loop through active makes and pull out the ones we are using
	.*-----------------------------------------*/
	for (var i = 0, j = window.rp_app.activeMakes.length; i < j; i++) {
		var active_make = window.rp_app.activeMakes[i];
		var use_this_make = false;
		if (!this.default_make || (this.default_make && this.default_make === active_make.url)) {
			use_this_make = true;
		}
		if (use_this_make === true) {
			year_makes.push(active_make);
		}
	}

	return year_makes;
};

/**
 * Get the makes and filter out by a certain year
 *
 * @author aspencer
 * @param  integer 		selected_year  	 Year make must include
 * @return null
 */
RP_VehiclePicker.prototype.makes_for_year = function (selected_year) {
	var i, j, active_make;
	var makes_for_year = [];

	selected_year = parseInt(selected_year, 10);

	for (i = 0, j = window.rp_app.activeMakes.length; i < j; i++) {
		active_make = window.rp_app.activeMakes[i];
		active_make.start_year = parseInt(active_make.start_year);
		active_make.end_year = parseInt(active_make.end_year);
		if (active_make.start_year <= selected_year && active_make.end_year >= selected_year) {
			makes_for_year.push(active_make);
		}
	}

	return makes_for_year;
};

/**
 * Get the active years from the current active makes
 *
 * @author aspencer
 * @return {Array<{ui: number, url: number}>}
 */
RP_VehiclePicker.prototype.get_active_years = function () {
	return buildActiveYearOptions(this.get_filtered_makes());
};

/**
 * Get request body to fetch step options
 *
 * @param  string step
 * @return object
 */
RP_VehiclePicker.prototype.get_request_body_for_step_options = function (step) {
	const request_body = {
		step,
		picker_type: this.picker_type,
		selected: {},
	};

	for (const opt_step in this.selected) {
		const option_obj = this.selected[opt_step];
		if (option_obj) {
			request_body.selected[opt_step] = option_obj.value;
		}
	}

	return request_body;
};

/********************************************
 * Ajax Methods
 * -----------------------------------------
 * @section ajax
 ********************************************/

/**
 * Wrapper for ajax requests with built-in retries
 *
 * @author aspencer
 * @param  string 		req_url 			Request URL
 * @param  object 		req_data 			Data to be sent to the server
 * @param  function 	success_function 	Function to be called on ajax success
 * @return null
 */
RP_VehiclePicker.prototype.ajax_request = function (req_url, req_data, success_function, retry_count) {

	/* Set up the retry_count
	.*-----------------------------------------*/
	if (typeof retry_count === 'undefined') {
		retry_count = 0;
		this.ajax_error_log = [];
	} else {
		retry_count++;
	}

	/* Test the retry count against the max. If we're over, FAIL
	.*-----------------------------------------*/
	this.ajax_max_retries = 0; //test
	if (retry_count > this.ajax_max_retries) {
		this.display_fatal_error();
		return;
	}

	/* Make the AJAX Request to the server
	.*-----------------------------------------*/
	var self = this;

	$ajax({
		method: 'post',
		url: req_url,
		data: req_data,
		dataType: 'json',
		success: success_function,
		error: function (xhr, textStatus, errorThrown) {
			/* If the request errors out, log the error and retry
			.*-----------------------------------------*/
			self.log_ajax_error(xhr.status + ': ' + errorThrown);
			self.ajax_request(req_url, req_data, success_function, retry_count);
		}
	});
};

/**
 * Push an error message to the ajax log
 *
 * @author aspencer
 * @param  string 		error_content 	Error string
 * @return null
 */
RP_VehiclePicker.prototype.log_ajax_error = function (error_content) {
	this.ajax_error_log.push(error_content);
};

/**
 * Display the fatal error message to the user
 * @TODO - do something useful with the error log
 *
 * @author aspencer
 * @return null
 */
RP_VehiclePicker.prototype.display_fatal_error = function () {
	//
	var $tab = this.$chooser.find('.vp_chooser_tab.active').first();
	var $options_wrapper = $tab.find('.vp_chooser_tab_options').first();
	$options_wrapper.empty();
	$options_wrapper.append('<div class="vp_chooser_error"><h2><span class="fa fa-exclamation-triangle"></span> ' + window.javascriptContent.server_problem_heading + '</h2><p>' + window.javascriptContent.server_problem_body + '</p></div>');
};

/**
 * Resolve chooser tab and options wrapper for a step
 *
 * @param {string} step Chooser step key (year|make|model|trim|engine)
 * @return {{$tab: jQuery, $options_wrapper: jQuery}}
 */
RP_VehiclePicker.prototype.get_tab_options = function (step) {
	const $tab = this.$chooser.find('.vp_chooser_tab_' + step).first();
	const $options_wrapper = $tab.find('.vp_chooser_tab_options').first();

	return { $tab, $options_wrapper };
};

/**
 * Show empty-state copy when a picker step returns no options
 *
 * Clears the loading spinner so empty catalog responses (e.g. no models for
 * year+make) do not leave the chooser spinning indefinitely. Shoppers can use
 * Start Over or change year/make via the breadcrumb.
 *
 * @param {string} step Current chooser step (year|make|model|trim|engine)
 * @return {void}
 */
RP_VehiclePicker.prototype.display_empty_options = function (step) {
	const { $options_wrapper } = this.get_tab_options(step);
	const body = window.javascriptContent.vehicle_picker_no_options_body;
	const model_heading_template = window.javascriptContent.vehicle_picker_no_models_heading;
	let heading = window.javascriptContent.vehicle_picker_no_options_heading;

	if (step === 'model' && model_heading_template) {
		const year_label = this.selected.year?.display ?? '';
		const make_label = this.selected.make?.display ?? '';
		heading = model_heading_template
			.replace('{year}', year_label)
			.replace('{make}', make_label)
			.replace(/\s+/g, ' ')
			.trim();
	}

	$options_wrapper.empty();
	$options_wrapper.append(
		'<div class="vp_chooser_error">' +
			'<h2><span class="fa fa-exclamation-triangle"></span> </h2>' +
			'<p></p>' +
		'</div>'
	);
	$options_wrapper.find('h2').append(document.createTextNode(heading));
	$options_wrapper.find('p').text(body);
};


/********************************************
 * Getter and Setter methods
 * -----------------------------------------
 * @section getters_setters
 ********************************************/


/**
 * Change the Picker Type & update markup
 *
 * @author aspencer
 * @param  string 		picker_type 	New value for the picker type
 * @return null
 */
RP_VehiclePicker.prototype.set_picker_type = function (picker_type) {
	this.picker_type = picker_type;

	/* Change the "Shop For" message on final page
	.*-----------------------------------------*/
	var $shopfor_ele = this.$chooser.find('.vp_picker_type_shopfor');
	var shopfor_text = 'Parts';
	if (this.picker_type === 'accessories') {
		shopfor_text = 'Accessories';
	}
	$shopfor_ele.html(shopfor_text);
};


/**
 * Set the default make (using 'url' value of window.rp_app.activeMakes)
 *
 * @author aspencer
 * @param  string 		make_value  	default make to use
 * @return null
 */
RP_VehiclePicker.prototype.set_default_make = function (make_value) {
	this.default_make = make_value;
};

/**
 * Jquery function hook
 *
 * @author aspencer
 * @param  Object		options 	User-supplied options
 * @return JQueryEle				JQuery element list for chaining
 */
rp$.fn.vehiclepicker = function (options) {
	return this.each(function () {
		this.vpicker = new RP_VehiclePicker(options, this);
	});
};


rp$.fn.vpicker = function () {
	var pickers = [];

	/* Loop through matching elements and pull out the pickers
	.*-----------------------------------------*/
	this.each(function () {
		if (this.vpicker) {
			pickers.push(this.vpicker);
		}
	});

	/* If only one element returned, flatten the array
	.*-----------------------------------------*/
	if (pickers.length === 1) {
		pickers = pickers.pop();
	}

	return pickers;
};

rp$.fn.vehiclepicker_link = function () {
	return this.each(function () {
		const $this = rp$(this);
		$this.on('click', function (event) {
			var make, model, year, trim, engine, redirect;

			/* Defaults From Element
			.*-----------------------------------------*/
			make = $this.attr('data-make');
			model = $this.attr('data-model');
			year = $this.attr('data-year');
			trim = $this.attr('data-trim');
			engine = $this.attr('data-engine');
			redirect = $this.attr('data-redirect');

			window.openVehiclePicker({ make, model, year, trim, engine, redirect });
			event.preventDefault();
		});
	});
};

module.exports = {
	getDataAndOpenVehiclePicker,
};
